import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getFamilyTypeList = store => store[NAME].familyTypeList;
export const getSexList = store => store[NAME].sexList;
export const getScholarshipList = store => store[NAME].scholarshipList;